export const stargateCreateLink = function (dataObject, landingSection) {
  if (!dataObject && landingSection) {
    console.warn('Stargate couldn\'t find provided dataObject or landingSection, aborting teleport...');
    return;
  }

  const activePortals = landingSection.querySelectorAll('[data-stargate][data-landing]');
  if (!activePortals.length) {
    console.warn('Stargate couldn\'t find any portal in provided landingSection, aborting teleport...');
    return;
  }

  Array.from(activePortals).map(landingPoint => {
    const path = landingPoint.getAttribute('data-landing');
    const root = landingPoint.closest('[data-root]');
    // ToDo: Traverse dataObject recursively for nested data!
    if (dataObject[path]) {
      if (root) root.classList.remove('hidden');
      dataTeleport(dataObject[path], landingPoint);
    } else {
      if (root) root.classList.add('hidden');
    }
  });

  console.log('Stargate teleport succeded!');
};

export const dataTeleport = function (dataPoint, landingTarget) {
  if (landingTarget.nodeName.toLowerCase() === "img") {
    landingTarget.src = dataPoint;
  } else {
    landingTarget.innerHTML = dataPoint;
  }
}
